import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import {
    columnsReducer,
    addEndumReducer, // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices 
    ipoReducer, netPositionReducer, newProductsReducer, watchlistReducer, mutualFundReducer,
    marketOverviewReducer, ordersReducer, recommendationReducer, newsReducer, eventReducer, holdingsReducer, dontMissReducer, alertsReducer,
    authReducer, notesReducer, screenersReducer, indicesReducer, portfolioReducer, fundsReducer, investmentsReducer, optionChainReducer,
    livePulseReducer, notificationsReducer, appInfoReducer, placeOrderMultilegReducer, modalsReducer, toastReducer, messagesReducer, wfhReducer, walkthroughPopoverReducer, settingReducer, edisReducer, helpReducer, calculatorReducer, guestUserReducer
} from './reducers';
import globalSearchReducer from './reducers/globalSearch';
import scripInfoReducer from './reducers/scripInfo';
import orderCartReducer from './reducers/orderCartReducer';
import { bIsProd } from '../utils/global_functions';
import loginReducer from './reducers/login';
import { saveState } from '../apis/models/indexdDB';
let PERSISTED_KEYS = ['login']; //Ameersha N --Reducers that need to be persisted should be added into this array ,else every reducer is blacklisted 
const appReducer = combineReducers({
    login: loginReducer,
    columns: columnsReducer,
    addendumreducer: addEndumReducer,// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices 
    watchList: watchlistReducer,
    netPosition: netPositionReducer,
    ipo: ipoReducer,
    newProducts: newProductsReducer,
    mutualFund: mutualFundReducer,
    marketOverview: marketOverviewReducer,
    orders: ordersReducer,
    recommendation: recommendationReducer,
    news: newsReducer,
    events: eventReducer,
    dontMiss: dontMissReducer,
    holdings: holdingsReducer,
    alerts: alertsReducer,
    notes: notesReducer,
    screeners: screenersReducer,
    auth: authReducer,
    indices: indicesReducer,
    portfolio: portfolioReducer,
    funds: fundsReducer,
    investments: investmentsReducer,
    livePulse: livePulseReducer,
    appInfo: appInfoReducer,
    globalSearch: globalSearchReducer,
    placeOrder: placeOrderMultilegReducer,
    modals: modalsReducer,
    toasts: toastReducer,
    walkthroughPopovers: walkthroughPopoverReducer,
    setting: settingReducer,
    messages: messagesReducer,
    notification: notificationsReducer,
    wfh: wfhReducer,
    scripInfo: scripInfoReducer,
    optionChain: optionChainReducer,
    guestUser: guestUserReducer,
    edis: edisReducer,
    help: helpReducer,
    orderCart: orderCartReducer, //SRIAKNTHRAO-ORDERCART
    calculator: calculatorReducer
});

const rootReducer = (state, action) => {
    if (action.type === "REHYDRATE") { //Ameersha N Function runs on app lods or reloads check fo any storage in IndexedDB if a storage for redux is present it will dispathc an action rehydrate the redux store
        const incoming = action.payload || {};
        const newState = { ...state };

        for (const key of PERSISTED_KEYS) {
            if (incoming[key] !== undefined) {
                newState[key] = incoming[key];
            }
        }

        return appReducer(newState, action);
    }

    return appReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: [thunk],
    devTools: !bIsProd() // This value as false will stop showing in data in redux devtools in build
});

let timeout;
store.subscribe(() => { //Ameersha N this event runs when ever the reudx updates , so it can perist in indexeddb
    clearTimeout(timeout);
    timeout = setTimeout(() => {
        const state = store.getState();
        const persisted = {};

        for (const key of PERSISTED_KEYS) {
            persisted[key] = state[key];
        }

        saveState('reduxState', {
            state: persisted,
            savedAt: Date.now()
        });
    }, 500);
});

